class UserAuthStrategy {
    authenticate() {
        throw new Error('Method authenticate() must be implemented');
    }
}

export default UserAuthStrategy;